export class FilterSelectionDate {

    arrival?: string;
    departure?: string;
    default?: string;

}


/*
 * 
 * NL selectecetern> 
 * selection[0] = {name: "NL", "amenitytId: 12", value: 4 };
 * Heel nederland?
 * 
 * 
 */

export class FilterSelectionLocation {

    selection = new Array<FilterSelectionLocationEntry>();

    customName?: string;

    getSelectionName() {

        // selection[0].name
        // or if multiplee items return string.join (...)
        //or if custom name => return custom name
    }

    hasValue(countNoPreference = true): boolean {
        // returns true if there is 'any' selection. note that
        // this will also unclide the no preference.

        if (countNoPreference) {
            return !!this.selection.length;
        } else {

            if (this.selection.length) {

                if (this.selection.length == 1) {

                    if (this.selection[0].countryNoPreference) {

                        // no preference means no value
                        return false;
                    }
                }

                // either 1 with not a no-country-preference,
                // or more than 1
                return true; 
            }

            return false;
        }
    }
}

export class FilterSelectionLocationEntry {

    countryName?: string;
    countryValueId?: number;
    countryNoPreference!: boolean;
    regionName?: string;
    regionValueId?: number;
    regionNoPreference!: boolean;
    cityName?: string;
    cityValueId?: number;
    cityNoPreference!: boolean;

    /**
     * has selected at least a country
     */
    hasSelection(): boolean  {

        return !!this.countryValueId;
    }

    getAsFormValue(): string | false {

        if (this.countryValueId) {
            let val = `${this.countryValueId}`;

            if (this.regionValueId) {

                val += `,${this.regionValueId}`;
            } else if (this.cityValueId) {

                val += `,-1`;
            }

            if (this.cityValueId) {

                val += `,${this.cityValueId}`;
            }
            return val;
        }
        else {
            return false;
        }
    };

}

export class FilterSelectionCompanions {

    numberOfAdults = 2;
    numberOfPets = 0;
    numberOfChildren = 0;
    numberOfBabies = 0;

}